import { __extends } from "tslib";
import cn from 'classnames';
import * as React from 'react';
import { getLoadableComponent } from '../../../../_library/utils/get-loadable-component';
import { config } from '../../config';
import { getClientConfig } from '../../utils/app-storage';
import { createDebugLogger } from '../../utils/app-utils';
import { ErrorBoundary } from '../ErrorBoundary';
import './DefaultLayout.scss';
import { NewVersionCheck } from '../NewVersionCheck';
import { ConnectivityCheck } from '../ConnectivityCheck';
import { AgentTypingIndicator } from '../SprinklrWebSocket/AgentTypingIndicator';
var DefaultLayout = /** @class */ (function (_super) {
    __extends(DefaultLayout, _super);
    function DefaultLayout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.debug = createDebugLogger('DefaultLayout');
        return _this;
    }
    DefaultLayout.prototype._segments = function () {
        var map = {};
        React.Children.forEach(this.props.children, function (child) {
            if (child.props.label) {
                if (map[child.props.label]) {
                    console.warn("Layout segment labeled as '".concat(child.props.label, "' already defined."));
                }
                else {
                    map[child.props.label] = child.props.children;
                }
            }
            else {
                console.warn("Expecting layout segment with 'label' prop.");
            }
        });
        return map;
    };
    DefaultLayout.prototype.render = function () {
        var B = config.css.B('-layout');
        var segments = this._segments();
        var h1 = this.props.h1;
        var cfg = getClientConfig();
        var PROJECT_TITLE = cfg.PROJECT_TITLE;
        h1 = h1 || PROJECT_TITLE;
        var HeaderSegment = function () {
            if ((cfg.HEADER || {}).DISABLED) {
                return null;
            }
            // ak je `header` segment explicitny null, tak nic, inak defaultujeme do <Header />
            // to je pre pripady, kedy nechcem header vobec davat (co je tu chapane ako vynimka)
            if (segments.header === null) {
                return null;
            }
            return (React.createElement("div", { className: cn("".concat(B, "__headerbox")) },
                React.createElement(ErrorBoundary, null, segments.header || getLoadableComponent('Header'))));
        };
        return (React.createElement(React.Fragment, null,
            h1 && React.createElement("h1", { className: "sr-only" }, h1),
            React.createElement("section", { className: B },
                React.createElement(HeaderSegment, null),
                React.createElement(ConnectivityCheck, null),
                React.createElement(NewVersionCheck, null),
                React.createElement(AgentTypingIndicator, null),
                React.createElement("div", { className: "".concat(B, "__mainbox") },
                    React.createElement(ErrorBoundary, null, segments.main)))));
    };
    return DefaultLayout;
}(React.Component));
export { DefaultLayout };
// function mapStateToProps(state: RootState, ownProps): DefaultLayoutProps {
//     return {
//         // isAuthenticated: authSelectors.identity.isAuthenticated(state),
//     };
// }
//
// const mapDispatchToProps = (dispatch, ownProps): DefaultLayoutProps => ({});
// export const DefaultLayout = withRouter(connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(DefaultLayoutClass) as any) as typeof DefaultLayoutClass;
